import React from "react";
import PropTypes from "prop-types";

export default class Post extends React.Component {
    render(){
        return(
            <div className="card card-hover">
                <div className="post-img">
                    <a href={`/resources/${this.props.identifier}/${this.props.post_id}`}>
                        <img className="card-img-top" src={`https://cdn.labx.com/${this.props.thumbnail}`} onError={this.addDefaultSrc} />
                    </a>
                </div>
                <div className="card-body">
                    <h2>
                        <a className="card-title" href={`/resources/${this.props.identifier}/${this.props.post_id}`}>
                            {this.props.title}
                        </a>
                    </h2>
                    <div className="card-section">
                        <p className="text-muted">{this.props.creation_time}</p>
                    </div>
                    <div className="card-section">
                        <p className="text-muted">{this.props.short_content}</p>
                    </div>
                    <div className="card-section">
                        <a className="" href={`/resources/${this.props.identifier}/${this.props.post_id}`}>
                            Read More
                        </a>
                    </div>
                </div>
            </div>
        );
    }
    addDefaultSrc(e){
        e.target.src = "/images/image-not-found.png";
    }
}

Post.propTypes = {
    thumbnail: PropTypes.string,
    identifier: PropTypes.string,
    post_id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    title: PropTypes.string,
    creation_time: PropTypes.string,
    short_content: PropTypes.string,
};
